import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy',
  standalone: false
})
export class SortByPipe implements PipeTransform {

  transform(items: any[], columns: string[], order: boolean): any[] | null {
    if (items?.length) {
      if (!columns || !columns.length) return items;
      return items.sort((a, b) => {
        for (let i=0; i<columns.length; i++) {
          if (a[columns[i]] === null && b[columns[i]] === null) return 0;
          if (a[columns[i]] === null && b[columns[i]] !== null) return order ?  1 : -1;
          if (a[columns[i]] !== null && b[columns[i]] === null) return order ? -1 :  1;

          if (typeof a[columns[i]] === 'string' && typeof b[columns[i]] === 'string') {
            if (a[columns[i]].toLowerCase() < b[columns[i]].toLowerCase()) return order ?  1 : -1;
            if (a[columns[i]].toLowerCase() > b[columns[i]].toLowerCase()) return order ? -1 :  1;
          }

          if (a[columns[i]] < b[columns[i]]) return order ?  1 : -1;
          if (a[columns[i]] > b[columns[i]]) return order ? -1 :  1;
        }
        return 0;
      });
    }
    return null;
  }
}
